import React from 'react';
import { IconBase } from '../Base';
export const IconBook = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M12 11.6651L2 15V5.32488L12 2V11.6651Z", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeMiterlimit: "10" }),
        React.createElement("path", { d: "M16.6314 15.5569L9.31868 17.9478C8.66933 18.1634 8 17.6833 8 17.0169V10.3048C8 9.46213 8.54945 8.70763 9.36863 8.44306L16.6813 6.05217C17.3307 5.8366 18 6.31674 18 6.98305V13.6952C18 14.5379 17.4505 15.2924 16.6314 15.5569Z", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeMiterlimit: "10" })));
};
//# sourceMappingURL=Book.js.map